export default __webpack_public_path__ + "static/media/submenu_5_off.857847d9.svg";